import { Outlet } from 'react-router-dom'

import { AccountsPayableUpsellModal } from 'modules/finance/components/AccountsPayableUpsellModal'
import FinancemodularroutesCollectionsBootstrap from 'modules/finance/lib/FinancemodularroutesCollectionsBootstrap'
import { FrequencyContextProvider } from 'modules/payroll_bundle/lib/frequencyContext'
import ProcurementsubmoduleCollectionsBootstrap from 'modules/procurement/lib/ProcurementsubmoduleCollectionsBootstrap'
import SoftwaremanagementsubmoduleCollectionsBootstrap from 'modules/software_management/lib/SoftwaremanagementsubmoduleCollectionsBootstrap'

const SpendingRootPage = () => {
  return (
    <FinancemodularroutesCollectionsBootstrap>
      <ProcurementsubmoduleCollectionsBootstrap>
        <SoftwaremanagementsubmoduleCollectionsBootstrap>
          <FrequencyContextProvider>
            <AccountsPayableUpsellModal source="ap_finance_upsellcard"></AccountsPayableUpsellModal>
            <Outlet />
          </FrequencyContextProvider>
        </SoftwaremanagementsubmoduleCollectionsBootstrap>
      </ProcurementsubmoduleCollectionsBootstrap>
    </FinancemodularroutesCollectionsBootstrap>
  )
}

export default SpendingRootPage
